<template>
  <div class="bg-white rounded-2xl shadow-lg p-6">
    <div class="mb-6">
      <h2 class="text-2xl font-bold text-gray-900 flex items-center gap-3">
        <span class="text-3xl">📘</span>
        <span>理解您的Holland Code</span>
      </h2>
    </div>

    <div class="p-6 bg-gradient-to-br from-blue-50 to-purple-50 rounded-xl">
      <!-- 祝贺语 -->
      <p class="text-base leading-relaxed text-gray-700 mb-5">
        恭喜您完成了霍兰德职业兴趣测评！通过这次深度探索，您现在更好地了解了自己的职业兴趣倾向。
        您的Holland Code是
        <strong class="text-xl mx-1" :style="{ color: primaryColor }">{{ primaryCode }}</strong>
        <strong class="text-xl mx-1" :style="{ color: secondaryColor }">{{ secondaryCode }}</strong>
        <strong class="text-xl mx-1" :style="{ color: tertiaryColor }">{{ tertiaryCode }}</strong>
        ，这代表您在<strong>{{ primaryName }}</strong>、<strong>{{ secondaryName }}</strong>和<strong>{{ tertiaryName }}</strong>这三个方面的兴趣最为突出。
      </p>

      <!-- 重要提示 -->
      <div 
        class="p-5 rounded-lg mb-5 border-l-4"
        :style="{
          backgroundColor: primaryColor + '10',
          borderColor: primaryColor
        }"
      >
        <p class="font-semibold mb-3 text-base" :style="{ color: primaryColor }">
          记住：Holland Code是发现方向的工具，而不是限制您的标签
        </p>
        <ul class="space-y-2 text-sm text-gray-700">
          <li class="flex items-start gap-2">
            <span>•</span>
            <span>拥抱您的职业兴趣，它们是您选择职业的重要参考</span>
          </li>
          <li class="flex items-start gap-2">
            <span>•</span>
            <span>保持开放心态，在不同领域中探索和尝试</span>
          </li>
          <li class="flex items-start gap-2">
            <span>•</span>
            <span>结合实际能力和机会，制定适合自己的职业规划</span>
          </li>
          <li class="flex items-start gap-2">
            <span>•</span>
            <span>将Holland Code作为职业发展的指南，而非唯一标准</span>
          </li>
        </ul>
      </div>

      <!-- 结束寄语 -->
      <div 
        class="text-center p-4 rounded-lg font-medium text-base"
        :style="{
          backgroundColor: primaryColor + '08',
          color: primaryColor
        }"
      >
        ✨ 愿这份报告帮助您找到真正适合的职业方向，在事业道路上发现更多可能性 ✨
      </div>
    </div>

    <!-- 下一步建议 -->
    <div class="mt-6 p-5 bg-gradient-to-r from-yellow-50 to-amber-50 rounded-xl border border-yellow-200">
      <h4 class="font-semibold text-amber-900 mb-3 flex items-center gap-2">
        <span>🎯</span>
        <span>接下来您可以：</span>
      </h4>
      <ul class="space-y-2 text-sm text-gray-700">
        <li class="flex items-start gap-2">
          <span class="text-amber-500">1.</span>
          <span>保存此报告，定期回顾您的职业兴趣特征</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-amber-500">2.</span>
          <span>与家人、老师或职业顾问分享讨论</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-amber-500">3.</span>
          <span>寻找同类型Holland Code的前辈，了解他们的职业路径</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-amber-500">4.</span>
          <span>将推荐的职业方向加入您的探索清单</span>
        </li>
        <li class="flex items-start gap-2">
          <span class="text-amber-500">5.</span>
          <span>一年后重新测试，观察自己的变化</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { HOLLAND_TYPES } from '../../data/hollandTypes'

/**
 * Holland Code 总结组件
 * 展示测试总结和后续建议
 */
export default {
  name: 'HollandCodeSummary',
  props: {
    hollandCode: {
      type: String,
      required: true
    }
  },
  computed: {
    // 提取三个代码
    primaryCode() {
      return this.hollandCode[0]
    },
    secondaryCode() {
      return this.hollandCode[1]
    },
    tertiaryCode() {
      return this.hollandCode[2]
    },
    
    // 获取类型信息
    primaryType() {
      return HOLLAND_TYPES[this.primaryCode]
    },
    secondaryType() {
      return HOLLAND_TYPES[this.secondaryCode]
    },
    tertiaryType() {
      return HOLLAND_TYPES[this.tertiaryCode]
    },
    
    // 类型名称
    primaryName() {
      return this.primaryType?.name
    },
    secondaryName() {
      return this.secondaryType?.name
    },
    tertiaryName() {
      return this.tertiaryType?.name
    },
    
    // 颜色
    primaryColor() {
      return this.primaryType?.color
    },
    secondaryColor() {
      return this.secondaryType?.color
    },
    tertiaryColor() {
      return this.tertiaryType?.color
    }
  }
}
</script>

